var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroppedPwd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1449_30448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FCE8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.48 10.1773C12.7813 10.1773 13.0373 10.0707 13.2506 9.85867C13.4626 9.64667 13.5693 9.38933 13.5693 9.088C13.5693 8.78667 13.4626 8.53067 13.2506 8.31733C13.0373 8.10667 12.7813 8 12.48 8C12.1786 8 11.9226 8.10667 11.7093 8.31867C11.496 8.53067 11.3906 8.788 11.3906 9.08933C11.3906 9.39067 11.4973 9.64667 11.7093 9.86C11.9226 10.072 12.1786 10.1773 12.48 10.1773Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2493 20.1591C12.3107 20.1591 11.5147 19.8271 10.8587 19.1631C10.204 18.4991 9.87733 17.6884 9.87733 16.7324C9.87733 15.7057 10.276 14.8471 11.072 14.1564L10.992 13.0938C10.3907 13.4844 9.908 14.0018 9.54533 14.6484C9.18267 15.2951 9 15.9897 9 16.7324C9 17.9364 9.416 18.9591 10.248 19.8004C11.08 20.6418 12.08 21.0617 13.2493 21.0617C14.0813 21.0617 14.856 20.8004 15.5733 20.2778C16.2907 19.7551 16.8173 19.1044 17.1533 18.3257L16.516 17.4497C16.356 18.2284 15.972 18.8751 15.3613 19.3884C14.7507 19.9018 14.0467 20.1591 13.2493 20.1591Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.889 18.0655H19.3317L17.1543 15.0642C16.853 14.5335 16.4903 14.2669 16.065 14.2669H13.621V13.1775H15.7983C16.1877 13.1775 16.3823 13.0402 16.3823 12.7655C16.3823 12.4909 16.1877 12.3535 15.7983 12.3535H13.621V11.2669C13.585 10.7175 13.2223 10.4522 12.5317 10.4695C11.9823 10.4869 11.709 10.7522 11.709 11.2669V15.0642C11.7623 15.6135 12.125 15.8869 12.7983 15.8869H16.065L17.977 18.3309L18.5077 19.1535H19.889C20.0303 19.1535 20.1543 19.1002 20.261 18.9935C20.3677 18.8869 20.421 18.7589 20.421 18.6082C20.421 18.4575 20.3677 18.3295 20.261 18.2229C20.1543 18.1189 20.0303 18.0655 19.889 18.0655Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1449_30448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7129 19.5312C23.7129 17.3221 21.922 15.5312 19.7129 15.5312C17.5038 15.5312 15.7129 17.3221 15.7129 19.5312C15.7129 21.7404 17.5038 23.5312 19.7129 23.5312C21.922 23.5312 23.7129 21.7404 23.7129 19.5312Z",
    fill: "#FCE8EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7129 16.5312C18.0571 16.5312 16.7129 17.8755 16.7129 19.5312C16.7129 21.187 18.0571 22.5312 19.7129 22.5312C21.3687 22.5312 22.7129 21.187 22.7129 19.5312C22.7129 17.8755 21.3687 16.5312 19.7129 16.5312ZM19.7129 17.4545C20.8591 17.4545 21.7897 18.3851 21.7897 19.5312C21.7897 20.6774 20.8591 21.608 19.7129 21.608C18.5667 21.608 17.6361 20.6774 17.6361 19.5312C17.6361 18.3851 18.5667 17.4545 19.7129 17.4545Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5848 18.9923L20.2506 20.6581C20.4131 20.8206 20.6773 20.8206 20.8398 20.6581C21.0023 20.4956 21.0023 20.2315 20.8398 20.069L19.1739 18.4031C19.0114 18.2406 18.7473 18.2406 18.5848 18.4031C18.4223 18.5656 18.4223 18.8298 18.5848 18.9923Z",
    fill: "#EA1F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2506 18.4031L18.5848 20.069C18.4223 20.2315 18.4223 20.4956 18.5848 20.6581C18.7473 20.8206 19.0114 20.8206 19.1739 20.6581L20.8398 18.9923C21.0023 18.8298 21.0023 18.5656 20.8398 18.4031C20.6773 18.2406 20.4131 18.2406 20.2506 18.4031Z",
    fill: "#EA1F4D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_30448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1449_30448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(15.7129 15.5312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroppedPwd);
export default __webpack_public_path__ + "static/media/dropped_PWD.e3083d0120ccb3d87edf6fb2aed4418f.svg";
export { ForwardRef as ReactComponent };